<div class="purchasing-fee-report-container">


  <div class="pageHeader" id="reportsHeader">
    <span>Adhoc Reports</span>
  </div>

  <div class="errorMessage " *ngIf="errorMessage.length">
    {{errHeading}}
    <li *ngFor="let message of errorMessage">{{message}}</li>
    <hr class="hrStyle">
  </div>

  <div>
  <div class="ui-g report-name">
    <div class="ui-g-3">Report Name:</div>
    <div class="ui-g-3"> Purchasing Fee Report</div>
  </div>


  <div class="ui-g" >
    <div class="ui-g-3">Fee Type:</div>
    <div class="ui-g-3">
      <div class="select-style">
        <fm-select [options]="feeTypes" ariaLabelledBy="default"
                   [(ngModel)]="selectedFeeType"></fm-select>
      </div>
    </div>
  </div>

  <div class="ui-g" >
    <div class="ui-g-3">Seller Number:</div>
    <div class="ui-g-3">
      <input type="text" maxlength="9"  maxlength="10" *ngIf="!isExternal"
             fmTextInput>

      <fm-select *ngIf="isExternal" [(ngModel)]="sellerNumber"
                 placeholder="&nbsp;"
                 ariaLabelledBy="default"
                 [options]="sellerList"
      ></fm-select>
    </div>
  </div>


  <div class="ui-g" >
    <div class="ui-g-3">Report Start Date:</div>
    <div class="ui-g-3">
      <fm-calendar id ="reportStartDate" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [(ngModel)]="reportingStartDate"
                   [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>

    </div>
  </div>


  <div class="ui-g" >
    <div class="ui-g-3">Report End Date:</div>
    <div class="ui-g-3">
      <fm-calendar id ="reportEndDate" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" [(ngModel)]="reportingEndDate"
                   [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>

    </div>
  </div>


  <div class="ui-g">
    <div class="ui-g-6">
      <button fmButton id="btnSubmit" type="submit" [primary]="true" [small]="true" label="Submit"
              class="buttonmargin" (click)="submit()"></button>
      <button fmButton id="btnClear" type="button" label="Clear" [small]="true" (click)="onClear()"
              class="buttonmargin"></button>
      <button fmButton id="btnCancel" type="button" label="Cancel" [small]="true" routerLink="/reverseMortgage"
              class="buttonmargin"></button>
    </div>
  </div>

  </div>

</div>
